var _defs, _path, _path2, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProCoreEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ProCore_Edge",
    "data-name": "ProCore Edge",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.175,
    height: 40,
    viewBox: "0 0 34.175 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1759",
    "data-name": "Rectangle 1759",
    width: 34.175,
    height: 39.999,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M1.369,1.368H13.377V38.631H1.369ZM0,40H34.175V0H0Z",
    transform: "translate(0 0.001)",
    fill: "#28478c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M13.636,11.869H5.812V6.733h7.824Zm-6.719-1.1h5.614V7.837H6.917Z",
    transform: "translate(-2.046 -2.369)",
    fill: "#314c88"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    "data-name": "Rectangle 1758",
    width: 0.995,
    height: 32.332,
    transform: "translate(15.059 3.498)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M7.227,18.879h-.99a.155.155,0,0,1-.155-.155v-.99a.156.156,0,0,1,.155-.155h.99a.156.156,0,0,1,.155.155v.99a.155.155,0,0,1-.155.155",
    transform: "translate(-2.42 -6.994)",
    fill: "#395185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M12.029,18.879h-.99a.155.155,0,0,1-.155-.155v-.99a.156.156,0,0,1,.155-.155h.99a.156.156,0,0,1,.155.155v.99a.155.155,0,0,1-.155.155",
    transform: "translate(-4.33 -6.994)",
    fill: "#314c88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M16.617,18.879h-.99a.155.155,0,0,1-.155-.155v-.99a.156.156,0,0,1,.155-.155h.99a.156.156,0,0,1,.155.155v.99a.155.155,0,0,1-.155.155",
    transform: "translate(-6.156 -6.994)",
    fill: "#395185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M39.555,22.258l-5.237,8.728h3.492v5.237L43.046,27.5H39.555Z",
    transform: "translate(-13.654 -8.856)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProCoreEdge);
export default __webpack_public_path__ + "static/media/ProCore Edge.28293cefcd79fd0f0e636b31cb557c7a.svg";
export { ForwardRef as ReactComponent };